import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/google_icon.png")